import {Alignment} from "@ckeditor/ckeditor5-alignment";
import {Bold, Code, Italic, Underline, Strikethrough} from "@ckeditor/ckeditor5-basic-styles";
import {CodeBlock} from "@ckeditor/ckeditor5-code-block";
import {DataFilter, DataSchema, GeneralHtmlSupport} from "@ckeditor/ckeditor5-html-support";
import {Essentials} from "@ckeditor/ckeditor5-essentials";
import {FindAndReplace} from "@ckeditor/ckeditor5-find-and-replace";
import {Heading} from "@ckeditor/ckeditor5-heading";
import {HorizontalLine} from "@ckeditor/ckeditor5-horizontal-line";
import {HtmlEmbed} from "@ckeditor/ckeditor5-html-embed";
import {
    AutoImage,
    Image,
    ImageCaption,
    ImageInsert,
    ImageResize,
    ImageStyle,
    ImageToolbar,
    ImageUpload
} from "@ckeditor/ckeditor5-image";
import {Indent, IndentBlock} from "@ckeditor/ckeditor5-indent";
import {AutoLink, Link, LinkImage} from "@ckeditor/ckeditor5-link";
import {List} from "@ckeditor/ckeditor5-list";
import {MediaEmbed} from "@ckeditor/ckeditor5-media-embed";
import {Paragraph} from "@ckeditor/ckeditor5-paragraph";
import {PasteFromOffice} from "@ckeditor/ckeditor5-paste-from-office";
import {Table, TableToolbar} from "@ckeditor/ckeditor5-table";
import {TextTransformation} from "@ckeditor/ckeditor5-typing";
import {ClassicEditor} from '@ckeditor/ckeditor5-editor-classic';
import {Autoformat} from "@ckeditor/ckeditor5-autoformat";
import {BlockQuote} from "@ckeditor/ckeditor5-block-quote";
import {FontBackgroundColor, FontColor, FontFamily, FontSize} from "@ckeditor/ckeditor5-font";
import {SimpleUploadAdapter} from "@ckeditor/ckeditor5-upload";
import { Style } from '@ckeditor/ckeditor5-style';
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';
import './translations/de';
import './translations/ro';

export default class CustomEditor extends ClassicEditor {}
CustomEditor.builtinPlugins = [
    Alignment,
    Style,
    Autoformat,
    AutoImage,
    AutoLink,
    BlockQuote,
    Bold,
    Code,
    Underline,
    Strikethrough,
    CodeBlock,
    DataFilter,
    DataSchema,
    Essentials,
    FindAndReplace,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    // Highlight,
    HorizontalLine,
    HtmlEmbed,
    Image,
    ImageCaption,
    ImageInsert,
    ImageResize,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    Indent,
    IndentBlock,
    Italic,
    Link,
    LinkImage,
    List,
    MediaEmbed,
    Paragraph,
    PasteFromOffice,
    Table,
    TableToolbar,
    TextTransformation,
    SimpleUploadAdapter,
    SourceEditing,
];

CustomEditor.defaultConfig = {
    toolbar: {
        items: [
            // 'heading',
            'style',
            '|',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'link',
            'bulletedList',
            'numberedList',
            'fontFamily',
            'fontSize',
            'fontBackgroundColor',
            'fontColor',
            // 'highlight',
            '|',
            'outdent',
            'indent',
            '|',
            'undo',
            'redo',
            '|',
            'imageInsert',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            '|',
            'findAndReplace',
            'horizontalLine',
            '|',
            // 'iframeEmbed',
            'htmlEmbed',
            'codeBlock',
            '|',
            'sourceEditing'
        ]
    },
    image: {
        toolbar: [
            'imageTextAlternative',
            'imageStyle:inline',
            'imageStyle:block',
            'imageStyle:side',
            'linkImage'
        ]
    },
    table: {
        contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
        ]
    },
    style: {
        definitions: [
            {
                name: "Memo Box",
                element: "p",
                classes: ["memo-box"]
            },
            {
                name: "Info box",
                element: "p",
                classes: ["info-box"]
            },
            {
                name: "Spoiler",
                element: "span",
                classes: ["spoiler"]
            },
        ],
    },
    toolbarStartupExpanded : false
};

export class CustomEditorNoMediaEmbed extends ClassicEditor {}
CustomEditorNoMediaEmbed.builtinPlugins = [
    Alignment,
    Style,
    Autoformat,
    AutoImage,
    AutoLink,
    BlockQuote,
    Bold,
    Underline,
    Strikethrough,
    Code,
    CodeBlock,
    DataFilter,
    DataSchema,
    Essentials,
    FindAndReplace,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    // Highlight,
    HorizontalLine,
    HtmlEmbed,
    Image,
    ImageCaption,
    ImageInsert,
    ImageResize,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    // MediaEmbed,
    Indent,
    IndentBlock,
    Italic,
    Link,
    LinkImage,
    List,
    Paragraph,
    PasteFromOffice,
    Table,
    TableToolbar,
    TextTransformation,
    SimpleUploadAdapter,
    SourceEditing,
];

CustomEditorNoMediaEmbed.defaultConfig = {
    toolbar: {
        items: [
            'heading',
            'style',
            '|',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'link',
            'bulletedList',
            'numberedList',
            'fontFamily',
            'fontSize',
            'fontBackgroundColor',
            'fontColor',
            // 'highlight',
            '|',
            'outdent',
            'indent',
            '|',
            'undo',
            'redo',
            '|',
            'imageInsert',
            'blockQuote',
            'insertTable',
            'imageUpload',
            // 'mediaEmbed',
            '|',
            'findAndReplace',
            'horizontalLine',
            '|',
            // 'iframeEmbed',
            'htmlEmbed',
            'codeBlock',
            '|',
            'sourceEditing'
        ]
    },
    image: {
        toolbar: [
            'imageTextAlternative',
            'imageStyle:inline',
            'imageStyle:block',
            'imageStyle:side',
            'linkImage'
        ]
    },
    table: {
        contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
        ]
    },
    style: {
        definitions: [
            {
                name: "Memo Box",
                element: "p",
                classes: ["memo-box"]
            },
            {
                name: "Info box",
                element: "p",
                classes: ["info-box"]
            },
            {
                name: "Spoiler",
                element: "span",
                classes: ["spoiler"]
            },
        ],
    },
    toolbarStartupExpanded : false
};
